import { render, staticRenderFns } from "./sportModal.vue?vue&type=template&id=1856167a&"
import script from "./sportModal.vue?vue&type=script&lang=js&"
export * from "./sportModal.vue?vue&type=script&lang=js&"
import style0 from "./sportModal.vue?vue&type=style&index=0&id=1856167a&prod&lang=scss&"
import style1 from "./sportModal.vue?vue&type=style&index=1&id=1856167a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports